<template>

    <v-modal title="Tag">

        <template #body>
            <v-alert :message="error" />
            <template v-if="project.tags.length">
                <v-form-group dir="ver" label="Tag">
                    <v-select :model="params.tag_id || ''" @input="params.tag_id = $event">
                        <option value="">Select Tag</option>
                        <option v-for="tag in project.tags" :key="tag.id" :value="tag.id">{{ tag.name }}</option>
                    </v-select>
                    <v-checkbox class="mt-15" label="Remove tag (if it exists)" :model="params.untag" @input="params.untag = $event" />
                </v-form-group>
            </template>
            <v-notice v-else size="sm" type="danger" message="Add a tag to use this action." />
        </template>

        <template #footer>
            <v-button size="sm" btn-style="white" @click.native="cancel">Cancel</v-button>
            <v-button size="sm" :loading="loading" @click.native="saveAction">Save</v-button>
        </template>

    </v-modal>

</template>

<script>

import ModalActionMixin from '@mixins/ModalActionMixin';

export default {

    mixins: [ModalActionMixin],

    data() {
        return {
            params: {
                type: this.action.type,
                tag_id: this.action.tag_id,
                untag: this.action.untag,
            },
        }
    },

}

</script>
